export const axisGridColor = 'rgba(255, 255, 255, 0.50)';

export const ticksColor = 'rgba(255, 255, 255, 0.50)';
